import {
  Button,
  Card,
  Grid,
  List,
  Modal,
  SearchBar,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const HomePage = styled.div`
  .body {
    // width:100%;
    padding: 0 10px 0 10px;
  }
  .ul {
    padding: 0;
    margin: 0;
    list-style: none;
    height: 180px;
    border: 1px solid #9e9e9e;
    border-radius: 5px;
    // display:flex;
    // flex-direction: column;
    // justify-content:space-around;
    overflow: hidden;
  }
  .ul li {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background-color:gray;
    margin-top: 5px;
  }
  .notice {
    width: 100%;
    height: 220px;
  }
  .notice_title {
    display: flex;
    justify-content: space-between;
    height: 40px;
    align-items: center;
  }
  .s1 {
    margin-left: 10px;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .s2 {
    margin-right: 10px;
  }
`;
interface Array1 {
  title: string;
  pushTime: string;
}
interface Array2 {
  title: string;
  startTime: string;
}
export default function HomePageList() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [noticeList, setNoticeList] = useState<Array1[]>([]);
  const [announcementList, setAnnouncementList] = useState<Array2[]>([]);

  useEffect(() => {
    instance.get(`/oa/releaseNotice/getReleaseNewSyGg`).then((resp) => {
      // console.log(resp)
      setNoticeList(resp.data.Data);
      console.log(resp.data.Data);
    });
  }, []);
  useEffect(() => {
    instance.get(`/oa/releaseNew/getReleaseNewSy`).then((resp) => {
      // console.log(resp);
      setAnnouncementList(resp.data.Data);
      console.log(resp.data.Data);
    });
  }, []);

  return (
    <>
      <HomePage>
        <div className="body">
          <div className="notice">
            <div className="notice_title">
              <span>通知</span>
              <span
                onClick={() => {
                  history.push(`/hr/homepage/morenotice`);
                }}
              >
                更多&gt;
              </span>
            </div>
            <ul className="ul">
              {noticeList.map((item) => (
                <li
                // onClick={() => {
                //   history.push(
                //     `/oa/html/caigou/showRelease?uuid=ecc51057643f4cba8a53fb576c952c2c&type=ggtz`
                //   );
                // }}
                >
                  <span className="s1">{item.title}</span>
                  <span className="s2">{item.pushTime}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="notice" style={{ marginTop: 10 }}>
            <div className="notice_title">
              <span>通告</span>
              <span>更多&gt;</span>
            </div>
            <ul className="ul">
              {announcementList.map((item) => (
                <li>
                  <span className="s1">{item.title}</span>
                  <span className="s2">{item.startTime}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="notice" style={{ marginTop: 10 }}>
            <div className="notice_title">
              <span>我的审批</span>
              <span>更多&gt;</span>
            </div>
            <ul className="ul">
              <li>
                <span className="s1">通知标题</span>
                <span className="s2">2021-09-02 18:00:00</span>
              </li>
            </ul>
          </div>
        </div>
      </HomePage>
    </>
  );
}
